import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

import { PhotoPreviewDialog } from '@/components/PhotoPreviewDialog';
import { Button } from '@/components/ui/button';

import { cn } from '@/lib/utils';

type Props = {
  url: string;
  label?: string;
  className?: string;
  onRemove?: () => void;
};

export const ImageTilePreview = (props: Props) => {
  const { url, label, className, onRemove } = props;
  const { t } = useTranslation();

  return (
    <div className={cn('relative size-20 shrink-0', className)}>
      <PhotoPreviewDialog
        src={url}
        title={label ?? ''}
      >
        <button
          type="button"
          aria-label={label}
          className="size-full overflow-hidden rounded-md border p-2"
        >
          <img
            src={url}
            alt={label}
            className="size-full object-contain"
          />
        </button>
      </PhotoPreviewDialog>
      {onRemove && (
        <Button
          type="button"
          variant="outline"
          size="icon-sm"
          className="absolute -top-2 -right-2 rounded-full"
          aria-label={t('Remove File')}
          onClick={onRemove}
        >
          <X />
        </Button>
      )}
    </div>
  );
};
